import React, { ReactNode } from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classNames from 'classnames';

import classes from './LeaderboardRowMobileWrapper.module.scss';

type LeaderboardRowMobileVariant = 'unstyled' | 'surface';

type LeaderboardRowMobileWrapperProps = {
  children: ReactNode;
  variant: LeaderboardRowMobileVariant;
};

const LeaderboardRowMobileWrapper = ({
  children,
  variant,
}: LeaderboardRowMobileWrapperProps) => {
  const cn = classNames(classes.grid, classes[variant]);

  switch (variant) {
    case 'unstyled':
      return <div className={cn}>{children}</div>;
    case 'surface':
      return <Surface className={cn}>{children}</Surface>;
  }
};

export { LeaderboardRowMobileWrapper, LeaderboardRowMobileVariant };
